export default __webpack_public_path__ + "static/media/banner-1.b18e93ab.jpg";